/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import * as models from "../index.js";

export type GetApiV4BoundaryNodeDataCentersResponse =
  | models.ListBoundaryNodeDataCentersResponse
  | models.ErrorT;

/** @internal */
export const GetApiV4BoundaryNodeDataCentersResponse$inboundSchema: z.ZodType<
  GetApiV4BoundaryNodeDataCentersResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  models.ListBoundaryNodeDataCentersResponse$inboundSchema,
  models.ErrorT$inboundSchema,
]);

/** @internal */
export type GetApiV4BoundaryNodeDataCentersResponse$Outbound =
  | models.ListBoundaryNodeDataCentersResponse$Outbound
  | models.ErrorT$Outbound;

/** @internal */
export const GetApiV4BoundaryNodeDataCentersResponse$outboundSchema: z.ZodType<
  GetApiV4BoundaryNodeDataCentersResponse$Outbound,
  z.ZodTypeDef,
  GetApiV4BoundaryNodeDataCentersResponse
> = z.union([
  models.ListBoundaryNodeDataCentersResponse$outboundSchema,
  models.ErrorT$outboundSchema,
]);

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV4BoundaryNodeDataCentersResponse$ {
  /** @deprecated use `GetApiV4BoundaryNodeDataCentersResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV4BoundaryNodeDataCentersResponse$inboundSchema;
  /** @deprecated use `GetApiV4BoundaryNodeDataCentersResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV4BoundaryNodeDataCentersResponse$outboundSchema;
  /** @deprecated use `GetApiV4BoundaryNodeDataCentersResponse$Outbound` instead. */
  export type Outbound = GetApiV4BoundaryNodeDataCentersResponse$Outbound;
}

export function getApiV4BoundaryNodeDataCentersResponseToJSON(
  getApiV4BoundaryNodeDataCentersResponse:
    GetApiV4BoundaryNodeDataCentersResponse,
): string {
  return JSON.stringify(
    GetApiV4BoundaryNodeDataCentersResponse$outboundSchema.parse(
      getApiV4BoundaryNodeDataCentersResponse,
    ),
  );
}

export function getApiV4BoundaryNodeDataCentersResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV4BoundaryNodeDataCentersResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV4BoundaryNodeDataCentersResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV4BoundaryNodeDataCentersResponse' from JSON`,
  );
}
